"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrows = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _ArrowsStyled = require("../styled/ArrowsStyled");
const Arrows = _ref => {
  let {
    align,
    color,
    rotation
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const arrowKey = `${themeMode}-${align}`;
  return /*#__PURE__*/_react.default.createElement(_ArrowsStyled.ArrowsStyled, {
    xmlns: "http://www.w3.org/2000/svg"
    // These are all locked to 8x8 px so the arrow's size is always the same, even for the
    // Lodestar arrows which are sometimes 4x8. This is incredibly important since popper
    // will reposition it whenever it changes size. If we're not careful, we can get into an
    // infinite loop of reposition=>resize=>reposition=>...
    ,
    viewBox: "0 0 8 8",
    width: "8",
    height: "8",
    color: color,
    style: {
      transform: `rotate(${rotation}deg)`
    }
  }, (() => {
    switch (arrowKey) {
      case "ursa-light-left":
        return /*#__PURE__*/_react.default.createElement("path", {
          d: "M8 0H0V4C0 4.82405 0.940764 5.29443 1.6 4.8L8 0Z",
          fill: "currentColor"
        });
      case "ursa-light-center":
        return /*#__PURE__*/_react.default.createElement("path", {
          d: "M3.16795 4.75192C3.56377 5.34566 4.43623 5.34566 4.83205 4.75192L8 0H0L3.16795 4.75192Z",
          fill: "currentColor"
        });
      case "ursa-light-right":
        return /*#__PURE__*/_react.default.createElement("path", {
          d: "M-2.38419e-07 0H8V4C8 4.82405 7.05924 5.29443 6.4 4.8L-2.38419e-07 0Z",
          fill: "currentColor"
        });
      case "lodestar-light-left":
        return /*#__PURE__*/_react.default.createElement("path", {
          d: "M4 0H0V6L4 0Z",
          fill: "currentColor"
        });
      case "lodestar-light-center":
        return /*#__PURE__*/_react.default.createElement("path", {
          d: "M4 6L8 0H0L4 6Z",
          fill: "currentColor"
        });
      case "lodestar-light-right":
        return /*#__PURE__*/_react.default.createElement("path", {
          d: "M4 0h4v6L4 0Z",
          fill: "currentColor"
        });
    }
  })());
};
exports.Arrows = Arrows;
//# sourceMappingURL=Arrows.js.map